var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#FFF4E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3346 19.6562H16.5013C16.0151 19.6562 15.5488 19.8494 15.2049 20.1932C14.8611 20.537 14.668 21.0034 14.668 21.4896V27.9063C14.668 28.3925 14.8611 28.8588 15.2049 29.2026C15.5488 29.5464 16.0151 29.7396 16.5013 29.7396H27.5013C27.9875 29.7396 28.4538 29.5464 28.7977 29.2026C29.1415 28.8588 29.3346 28.3925 29.3346 27.9063V21.4896C29.3346 21.0034 29.1415 20.537 28.7977 20.1932C28.4538 19.8494 27.9875 19.6562 27.5013 19.6562H25.668",
    stroke: "#F79009",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24.2422V13.2422M24.75 15.9922L22 13.2422L19.25 15.9922",
    stroke: "#F79009",
    strokeWidth: 1.83333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/Logout-icon.03d54a25d2ae4873dc0b10175523ef1f.svg";
export { ForwardRef as ReactComponent };